import moment from 'moment-timezone';

export const timestampConversion = (
  timestamp,
  timezone = 'America/Chicago',
  timestampFormat = 'YYYY-MM-DD HH:mm:ss',
  returnFormat = 'MM/DD/YYYY hh:mm:ss A'
) => moment.utc(timestamp, timestampFormat).tz(timezone).format(returnFormat);
